import { render, staticRenderFns } from "./AppReviewList.vue?vue&type=template&id=496f48d7&scoped=true"
import script from "./AppReviewList.vue?vue&type=script&lang=js"
export * from "./AppReviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496f48d7",
  null
  
)

export default component.exports